import { render, staticRenderFns } from "./ViewPhoto.vue?vue&type=template&id=866853b6&"
import script from "./ViewPhoto.vue?vue&type=script&lang=ts&"
export * from "./ViewPhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports